module.exports = __webpack_public_path__ + "static/media/amosova_logo.76fb128e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/amosova_logo.jpg
// module id = 62
// module chunks = 0